import { createFileRoute } from "@tanstack/react-router";
import { getPublicChart } from "../../services/public-chart";
import { pageHead } from "../../utils/page-title";

export const Route = createFileRoute("/charts/$chartId")({
  loader: ({ params }) => getPublicChart({ data: params.chartId }),
  head: ({ params, loaderData }) =>
    pageHead(loaderData ? `${loaderData.displayName}’s Chart` : "Shared Chart", {
      description: loaderData
        ? `Explore ${loaderData.displayName}’s Human Design chart and request to be friends on Harness.`
        : "Explore a shared Human Design chart on Harness.",
      canonicalPath: `/charts/${params.chartId}`,
      robots: "noindex, nofollow",
    }),
});
